module.exports = __webpack_public_path__ + "static/media/13.928ed6d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/13.jpg
// module id = 188
// module chunks = 0